/**
 * @license The MIT License (MIT)
 * @copyright Igor Zaporozhets Kalashnik <deadbyelpy@gmail.com>
 */

'use strict';

// public
module.exports = function ( func, wait ) {
    var timeout;

    return function () {
        var self = this,
            args = arguments;

        clearTimeout(timeout);

        // Set the new timeout
        timeout = setTimeout(function () {
            timeout = null;
            func.apply(self, args);
        }, wait);
    };
};
